import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';
import {
	CPCreqHistoryAdditionalAgreementSharedLocNames,
	creqAdditionalAgreementSharedLocs,
} from '../../models/additional-agreement.locs';

export type CPCReqHistoryAdditionalAgreementLocNames =
	| 'CPCReqHistoryAdditionalAgreementPageTitle'
	| 'CPCReqHistoryAdditionalAgreementPageDescription'
	| 'CPCReqHistoryAdditionalAgreementGroupNameLabel'
	| 'CPCReqHistoryAdditionalAgreementNameLabel'
	| 'CPCReqHistoryAdditionalAgreementActiveDateLabel'
	| 'CPCReqHistoryAdditionalAgreementExpireDateLabel'
	| 'CPCReqHistoryAdditionalAgreementButtonGoBack'
	| 'CPCReqHistoryAdditionalAgreementButtonInfo'
	| 'CPCReqHistoryAdditionalAgreementButtonViewMore'
	| 'CPCReqHistoryAdditionalAgreementContentPageDescription'
	| CPCreqHistoryAdditionalAgreementSharedLocNames;

export const creqAdditionalAgreementLocs: LocDefs<CPCReqHistoryAdditionalAgreementLocNames> = {
	CPCReqHistoryAdditionalAgreementPageTitle: {
		defaultValue: 'Additional Agreements',
		description: 'Page title for: Additional Agreements.',
		displayPath: 'History|Additional Agreement|Page Title',
		portal: 'CP',
		displayType: 'Title',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.AdditionalAgreement.Title.PageTitle',
	},
	CPCReqHistoryAdditionalAgreementPageDescription: {
		defaultValue: 'Additional Agreements',
		description: 'Page description for: Additional Agreements.',
		displayPath: 'History|Additional Agreement|Page Description',
		portal: 'CP',
		displayType: 'Content',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: true,
		shared: false,
	},

	CPCReqHistoryAdditionalAgreementButtonGoBack: {
		defaultValue: 'Go Back',
		description: 'Button label for: Go Back.',
		displayPath: 'History|Additional Agreement|Go Back',
		portal: 'CP',
		displayType: 'Button',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.AdditionalAgreement.Button.GoBack',
	},
	CPCReqHistoryAdditionalAgreementButtonInfo: {
		defaultValue: 'Info',
		description: 'Button label for: Info.',
		displayPath: 'History|Additional Agreement|Info',
		portal: 'CP',
		displayType: 'Button',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.AdditionalAgreement.Button.Info',
	},
	CPCReqHistoryAdditionalAgreementButtonViewMore: {
		defaultValue: 'View More',
		description: 'Button label for: View More.',
		displayPath: 'History|Additional Agreement|View More',
		portal: 'CP',
		displayType: 'Button',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.AdditionalAgreement.Button.ViewMore',
	},

	...creqAdditionalAgreementSharedLocs,
	CPCReqHistoryAdditionalAgreementContentPageDescription: {
		defaultValue: 'Additional Agreements',
		description: 'Page description for: Additional Agreements.',
		displayPath: 'History|Additional Agreement|Page Description',
		portal: 'CP',
		displayType: 'Content',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: true,
		shared: false,
		legacyName: 'OtherRequirement/History.AdditionalAgreement.Content.PageDescription',
	},

	CPCReqHistoryAdditionalAgreementGroupNameLabel: {
		defaultValue: 'Group',
		description: 'Field label for: Group.',
		displayPath: 'History|Additional Agreement|Group',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.AdditionalAgreement.FieldLabel.GroupName',
	},
	CPCReqHistoryAdditionalAgreementNameLabel: {
		defaultValue: 'Name',
		description: 'Field label for: Name.',
		displayPath: 'History|Additional Agreement|Name',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.AdditionalAgreement.FieldLabel.Name',
	},
	CPCReqHistoryAdditionalAgreementActiveDateLabel: {
		defaultValue: 'Active Date',
		description: 'Field label for: Active Date.',
		displayPath: 'History|Additional Agreement|Active Date',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.AdditionalAgreement.FieldLabel.ActiveDate',
	},
	CPCReqHistoryAdditionalAgreementExpireDateLabel: {
		defaultValue: 'Expire Date',
		description: 'Field label for: Expire Date.',
		displayPath: 'History|Additional Agreement|Expire Date',
		portal: 'CP',
		displayType: 'Label',
		feature: HubFeature.OtherRequirement,
		htmlAllowed: false,
		shared: false,
		legacyName: 'OtherRequirement/History.AdditionalAgreement.FieldLabel.ExpireDate',
	},
};

export const creqAdditionalAgreementPageLocs: Pick<
	LocMap<CPCReqHistoryAdditionalAgreementLocNames>,
	'CPCReqHistoryAdditionalAgreementPageTitle' | 'CPCReqHistoryAdditionalAgreementPageDescription'
> = {
	CPCReqHistoryAdditionalAgreementPageTitle: 'CPCReqHistoryAdditionalAgreementPageTitle',
	CPCReqHistoryAdditionalAgreementPageDescription:
		'CPCReqHistoryAdditionalAgreementPageDescription',
};

export const cpCreqAdditionalAgreementLocKeys =
	MapLocKeys<CPCReqHistoryAdditionalAgreementLocNames>(creqAdditionalAgreementLocs);
export type CPCreqHistoryAdditionalAgreementLocKeys = typeof cpCreqAdditionalAgreementLocKeys;
